// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29I4Z","right":"styles_right__3nI-s"};